// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__31p-q","footerInner":"style_footerInner__1ju-2","logo":"style_logo__1vnSC"};